
//  export const backurl      =    "http://localhost:8067" // local
  // export const backurl   =    "http://43.204.99.101:8067" // testnet
  export const backurl = "https://api.stablezarc.io" // mainnet

export const frontendurl  =     window.location.origin;
export const TENMINUTESINMILISECONDS = 600000;
export const TENMINUTESINSECONDS = 600;
